// src/api/borrowerPortal/borrowerProfile.js
import { api } from "../client";

/**
 * Remove NI field from any outgoing payload (matches your requirement)
 */
function stripSensitive(fields) {
  if (!fields || typeof fields !== "object") return fields;
  const cleaned = { ...fields };
  delete cleaned.national_insurance_number;
  delete cleaned.nationalInsurance;
  delete cleaned.national_insurance;
  return cleaned;
}

// Unwrap API response - Frappe REST API returns { data: { ...doc } }
const unwrap = (res) => {
  // Axios response structure: response.data contains the API response
  // API response structure: { data: { ...doc } }
  const apiResponse = res?.data;
  
  // If response has data.data, return it wrapped for consistency
  if (apiResponse?.data) {
    return { data: apiResponse.data };
  }
  
  // If response is the doc directly
  if (apiResponse && typeof apiResponse === 'object' && !apiResponse.message) {
    return { data: apiResponse };
  }
  
  // Fallback for different response structures
  return apiResponse?.message ?? apiResponse ?? res;
};

/**
 * Frappe REST:
 * GET  /api/resource/Borrower Profile/{name}
 * PUT  /api/resource/Borrower Profile/{name}
 * POST /api/resource/Borrower Profile
 */

/**
 * GET /api/resource/Borrower Profile/{profileName}
 * Example: https://dynesourcerbackend.co.uk/api/resource/Borrower Profile/test2@example.com
 */
export async function getBorrowerProfile(profileName) {
  if (!profileName || profileName.trim() === "") {
    throw new Error("Profile name is required");
  }
  const encoded = encodeURIComponent(profileName);
  const res = await api.get(`/api/resource/Borrower Profile/${encoded}`);
  return unwrap(res);
}

/**
 * PUT /api/resource/Borrower Profile/{profileName}
 * Example: https://dynesourcerbackend.co.uk/api/resource/Borrower Profile/test2@example.com
 */
export async function updateBorrowerProfile(profileName, fields) {
  if (!profileName || profileName.trim() === "") {
    throw new Error("Profile name is required");
  }
  const encoded = encodeURIComponent(profileName);
  const payload = stripSensitive(fields);

  const res = await api.put(`/api/resource/Borrower Profile/${encoded}`, payload);
  return unwrap(res);
}

/**
 * POST /api/resource/Borrower Profile
 * Example: https://dynesourcerbackend.co.uk/api/resource/Borrower Profile
 */
export async function createBorrowerProfile(fields) {
  const payload = stripSensitive(fields);

  const res = await api.post(`/api/resource/Borrower Profile`, payload);
  return unwrap(res);
}
